module.exports = __webpack_public_path__ + "static/media/Plateau_L_4.aff341e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/Plateau_L_4.svg
// module id = 789
// module chunks = 0